import classnames from "classnames";
import * as React from "react";

import { Link, useEnhancedTableStyles } from "../../";

interface TableCellRouteProps {
    pathname: string;
    search?: string;
    backUrl?: string;
    navigationArray?: any[];
    children: React.ReactNode;
    className?: string;
    title?: string;
}

export const TableCellRoute = (props: TableCellRouteProps) => {
    const classes = useEnhancedTableStyles(props);
    const {
        className,
        title,
        pathname,
        search,
        backUrl,
        navigationArray,
        children,
    } = props;

    const tableCellClasses = classnames(className, classes.tableCellLink);

    return (
        <Link
            className={tableCellClasses}
            gutterBottom={false}
            title={title}
            to={{
                pathname: pathname,
                search: search,
                state: backUrl && {
                    backUrl: backUrl,
                    navigationArray: navigationArray,
                },
            }}
        >
            {children}
        </Link>
    );
};
